import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, take, switchMap, catchError, map, filter } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';
import { SetTitle, SetTags } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';

export const MuseumCollectionMetaGuard: CanActivateFn = route => {
  const store = inject(Store);
  const lang = inject(LanguageService);
  const dict = new FromDictionaryPipe(lang);
  return store
    .select(fromStore.getSelectedMuseumCollection)
    .pipe(
      tap(collection => {
        if (!collection) {
          return;
        }
        store.dispatch(
          SetTitle({
            title: `${collection?.metaData?.title || collection?.title} ${
              dict.transform('meta-titel-suffix') ? '- ' + dict.transform('meta-titel-suffix') : ''
            }`,
          })
        );
        store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.stripHtmlTags(collection.metaData.description), 157, '...'),
              'og:image': collection.metaData.imageUrl ? `https:${collection.metaData.imageUrl}` : '',
              'og:title': `${collection.metaData.title} ${dict.transform('meta-titel-suffix')}`,
              'og:description': StringUtility.Truncate(StringUtility.stripHtmlTags(collection.metaData.description), 157, '...'),
              'keywords': `${collection.metaData.keywords?.join(',')}`,
            },
          })
        );
      }),
      filter(a => a?.id > 0),
      map(a => true),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
